import { render } from "./hyCenter.vue?vue&type=template&id=dde14972"
import script from "./hyCenter.vue?vue&type=script&lang=js"
export * from "./hyCenter.vue?vue&type=script&lang=js"

import "./hyCenter.vue?vue&type=style&index=0&id=dde14972&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__